export const LIMIT_TYPES = [
    {key: "FOREIGN_CAR", name: "Для иномарок", nameRu: "Чет эл машиналари учун"}
];
export const EXIST_NOT_EXIST = [
    {key: "EXIST", name: "Мавжуд", nameRu: "Имеется"},
    {key: "NOT_EXIST", name: "Мавжуд эмас", nameRu: "Не имеется"}
];
export const TECHNICAL_CONDITION_OF_CAR = [
    {key: "New", name: "Янги", id: 1},
    {key: "VeryGood", name: "Жуда яхши", id: 2},
    {key: "Good", name: "Яхши", id: 3},
    {key: "Satisfactory", name: "Қониқарли", id: 4},
    {key: "ConditionallyAvailable", name: "Шартли равишда яроқли", id: 5},
    {key: "Dissatisfied", name: "Қониқарсиз", id: 6},
    {key: "UnusableOrLame", name: "Қўллашга яроқсиз ёки лом", id: 7}
];
export const AUTO_PART_CONDITIONS = [
    {key: "Accessible", name: "Соз"},
    {key: "Defective", name: "Носоз"},
    {key: "RepairNeeded", name: "Таъмирталаб"}
];
export const AUTO_SALON_PART_CONDITIONS = [
    {key: "Accessible", name: "Соз"},
    {key: "RepairNeeded", name: "Таъмирталаб"}
];
export const TECHNICAL_CONDITIONS = [
    {key: "Accessible", name: "Техник соз"},
    {key: "Defective", name: "Техник носоз"}
];

export const FUEL_TYPE = [
    {key: "BENZIN", name: "Бензин"},
    {key: "METAN", name: "Бензин/Метан"},
    {key: "PROPAN", name: "Бензин/Пропан"},
    {key: "DIESEL_METHANE", name: "Дизель/Метан"},
    {key: "DIESEL_PROPANE", name: "Дизель/Пропан"},
    {key: "DIESEL", name: "Дизель"}
];

export const PRICE_CONDITIONS = [
    {value: 0, text: '0%'},
    {value: -5, text: '-5%'},
    {value: -10, text: '-10%'},
    {value: -15, text: '-15%'}
];

export const CORRECTION_TYPE_ENUM = [
    {PurposeEvaluationResults : "Баҳолаш ёндашуви ҳисобланаётган қиймат тури, баҳолаш мақсади ва баҳолаш натижаларидан фойдаланиш мўлжалига мувофиқлиги"},
    {CharacteristicsEvaluationObject: "Фойдаланилган ҳисоблаш усуллари мавжуд бозор ахборотига мувофиқлиги"},
    {DetailsBasisAnalysisCalculations: "Таҳлил ва ҳисоблашларга асос бўлган ахборотнинг ишончлилиги ва етарлилиги"},
    {AssessmentApproachReflectingMotivationBuyersSellers: "Баҳолаш ёндашуви баҳолаш объектига ўхшаш объектларнинг одатдаги харидорлари ва сотувчилари мотивациясини акс эттиришга қодирлиги"},
    {ValuationApproachCodingConjuncture: "Баҳолаш ёндашуви бозор конъюктурасини ҳисобга олишга қодирлиги"},
    {NatureOfObjectOfAssessment: "Баҳолаш объекти типига ва ундан фойдаланиш хусусиятига мувофиқлиги"},
    {SpecificDimensionsApproaches: "Баллар қийматининг жами"}
];